export default __webpack_public_path__ + "static/media/payment-failed.994da21b.svg";